import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import * as React from 'react';
import toast from 'react-hot-toast';

import api from '@/lib/api';
import { ApiError } from '@/types/api';
import { RegisterRequest, RegisterResponse } from '@/types/register';

export const useRegisterMutation = ({
  setEmail,
}: {
  setEmail: React.Dispatch<React.SetStateAction<string>>;
}) => {
  let email = '';
  const { mutate, isPending } = useMutation<
    AxiosResponse,
    AxiosError<ApiError>,
    RegisterRequest
  >({
    mutationFn: (data: RegisterRequest) => {
      email = data.email;
      return api.post<AxiosResponse<RegisterResponse>>('/auth/signup', data);
    },
    onSuccess: () => {
      setEmail(email);
      toast.success('Akun berhasil dibuat, silahkan cek email Anda');
    },
    onError: (error) => {
      toast.error(
        error.response?.data.message ||
          'Gagal membuat akun, silahkan coba lagi',
      );
    },
  });

  return { mutate, isPending };
};
